export const QuickLinks = (() => {
	'use strict';

	function init() {
	}

	return {
		init: init,
	};
})();
